import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import { iots } from '@code-expert/prelude';
import { TaskId } from '/imports/domain/identity';
import { QuestionId } from './Question';
import { QuizSettingsC } from './QuizSettings';

//--------------------------------------------------------------------------------------------------

export const QuizIdBrand = Symbol('QuizId');
export const QuizId = mkEntityIdCodec(QuizIdBrand);
export type QuizId = iots.TypeOf<typeof QuizId>;

//--------------------------------------------------------------------------------------------------

export const Quiz = iots.strict({
  _id: QuizId,
  taskId: TaskId,
  createdAt: iots.date,
  updatedAt: iots.date,
  description: iots.string,
  questionIds: iots.array(QuestionId),
  settings: QuizSettingsC,
});

export type Quiz = iots.TypeOf<typeof Quiz>;

//--------------------------------------------------------------------------------------------------
